import { render, staticRenderFns } from "./NuevoDesarrolladores.vue?vue&type=template&id=36c4323a&scoped=true"
import script from "./NuevoDesarrolladores.vue?vue&type=script&lang=js"
export * from "./NuevoDesarrolladores.vue?vue&type=script&lang=js"
import style0 from "./NuevoDesarrolladores.vue?vue&type=style&index=0&id=36c4323a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4323a",
  null
  
)

export default component.exports